module.exports = __webpack_public_path__ + "static/img/banner.61dd5159.png";